import { C as o } from "../../../../brands-CoixlYYY.js";
import m from "../../../utils/createTheme.mjs";
import r from "./componentColors.mjs";
import t from "./componentStyles/index.mjs";
import e from "./fonts.mjs";
const a = m({
  id: o,
  componentColors: r,
  fonts: e,
  components: t
});
export {
  a as default
};
